/** Shared 501 checkout routes / hints (scoreboard + camera). */

export const CHECKOUT_MAP = {
  170: ["T20 • T20 • Bull"], 167: ["T20 • T19 • Bull"],
  164: ["T20 • T18 • Bull", "T19 • T19 • Bull"], 161: ["T20 • T17 • Bull"],
  160: ["T20 • T20 • D20"], 158: ["T20 • T20 • D19"],
  157: ["T20 • T19 • D20"], 156: ["T20 • T20 • D18"],
  155: ["T20 • T19 • D19"], 154: ["T20 • T18 • D20", "T19 • T19 • D20"],
  153: ["T20 • T19 • D18"], 152: ["T20 • T17 • D20", "T20 • T20 • D16"],
  151: ["T20 • T17 • D18"], 150: ["T20 • T18 • D18", "T20 • T20 • D15"],
  149: ["T20 • T19 • D16"], 148: ["T20 • T16 • D20", "T20 • T20 • D14"],
  147: ["T20 • T17 • D16"], 146: ["T20 • T14 • D20", "T19 • T19 • D16"],
  145: ["T20 • T15 • D20"], 144: ["T20 • T20 • D12"],
  143: ["T20 • T17 • D12"], 142: ["T20 • T14 • D18", "T20 • T20 • D11"],
  141: ["T20 • T15 • D18"], 140: ["T20 • T20 • D10", "T20 • T16 • D16"],
  139: ["T19 • T14 • D20"], 138: ["T20 • T18 • D12", "T20 • T16 • D15"],
  137: ["T19 • T16 • D16"], 136: ["T20 • T20 • D8", "T20 • T16 • D14"],
  135: ["T20 • T15 • D15", "T20 • T17 • D12"], 134: ["T20 • T14 • D16", "T20 • T18 • D10"],
  133: ["T20 • T17 • D11", "T20 • T19 • D8"], 132: ["T20 • T16 • D12", "T20 • T20 • D6"],
  131: ["T20 • T13 • D16"], 130: ["T20 • T18 • D8", "T20 • T10 • D20"],
  129: ["T19 • T16 • D12"], 128: ["T18 • T14 • D16", "T20 • T20 • D4"],
  127: ["T20 • T17 • D8"], 126: ["T19 • T19 • D6", "T20 • T16 • D9"],
  125: ["T20 • T19 • D4", "T20 • T15 • D10"], 124: ["T20 • T16 • D8", "T20 • D16 • D16"],
  123: ["T19 • T16 • D9"], 122: ["T18 • T16 • D10"],
  121: ["T20 • T11 • D14", "T17 • T14 • D16"], 120: ["T20 • S20 • D20"]
};

export const getCheckoutRoutes = (score) => {
  if (score > 170 || score < 2 || [169, 168, 166, 165, 163, 162, 159].includes(score)) return [];
  if (CHECKOUT_MAP[score]) return CHECKOUT_MAP[score];
  let routes = [];
  if (score <= 40 && score % 2 === 0) routes.push(`Double ${score / 2}`);
  if (score === 50) routes.push("Bullseye");
  if (score <= 60 && score > 40 && score !== 50) {
    const sTops = score - 40, sD16 = score - 32, sD18 = score - 36;
    if (sTops > 0 && sTops <= 20) routes.push(`S${sTops} • D20`);
    if (sD16 > 0 && sD16 <= 20) routes.push(`S${sD16} • D16`);
    if (sD18 > 0 && sD18 <= 20) routes.push(`S${sD18} • D18`);
  }
  if (routes.length === 0 && score < 40 && score % 2 !== 0) {
    if (score > 17) routes.push(`S1 • D${(score - 1) / 2}`);
    if (score > 19) routes.push(`S3 • D${(score - 3) / 2}`);
  }
  return routes.length > 0 ? routes : ["Work Down to Preferred Double"];
};

export const checkoutHintFor = (score) => {
  const routes = getCheckoutRoutes(score);
  return routes[0] || '';
};
